<template>
  <el-submenu
    v-if="menu.children && menu.children.length >= 1"
    :index="'' + menu.id"
    :popper-append-to-body="false">
    <template slot="title">
      <i :class="['menuIcon','iconfont', menu.icon]" />
      <span slot="title">{{ menu.title }}</span>
    </template>
    <MenuTree
      v-for="item in menu.children"
      :key="item.id"
      :menu="item"/>
  </el-submenu>
  <el-menu-item v-else :index="'' + menu.id" @click="handleRoute(menu)">
    <i :class="['menuIcon','iconfont', menu.icon]" />
    <span slot="title">{{ menu.title }}</span>
  </el-menu-item>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MenuTree',
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isLogined'])
  },
  data () {
    return {
    }
  },
  methods: {
    handleRoute (menu) {
      // 通过菜单URL跳转至指定路由
      if (this.$route.path !== '/' + menu.url) {
        this.$router.push(menu.url)
      }
    }
  }
}
</script>

<style>
  .menuIcon{
    font-size: 20px;
    margin-right: 6px;
  }
</style>
